import { render, staticRenderFns } from "./ReviewImages.vue?vue&type=template&id=221575db&scoped=true"
import script from "./ReviewImages.vue?vue&type=script&lang=js"
export * from "./ReviewImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221575db",
  null
  
)

export default component.exports